exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collections-list{list-style:none;padding:0;margin:0}", ""]);

// exports
